// extracted by mini-css-extract-plugin
module.exports = {"Label":"RatingLabel_Label__Y71Bm"};